module.exports = __webpack_public_path__ + "static/media/smallTodoList.1054dd78.png";